import { useQuery } from '@tanstack/react-query';
import { leaveService } from '@/services/leave/leaveService';
import { leaveQueryKeys } from './queryKeys';

interface UseCompanyLeaveRequestsOptions {
  employeeId?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

export const useCompanyLeaveRequests = (options?: UseCompanyLeaveRequestsOptions) => {
  return useQuery({
    queryKey: leaveQueryKeys.companyRequestsFiltered(options?.employeeId, options?.status, options?.limit, options?.offset),
    queryFn: () => leaveService.getCompanyLeaveRequests(options),
    staleTime: 2 * 60 * 1000, // 2 minutes (more frequent for managers)
  });
};
